/**
 * Slider Module
 * Splide.jsを使用したスライダー機能
 */
export class Slider {
  constructor() {
    this.sliders = document.querySelectorAll('.js-slider');
    this.splideInstances = [];
    
    if (this.sliders.length > 0) {
      this.init();
    }
  }
  
  /**
   * 初期化
   */
  init() {
    // Splide.jsが読み込まれているか確認（少し遅延を入れて確認）
    const checkSplide = () => {
      if (typeof Splide === 'undefined') {
        setTimeout(checkSplide, 100);
        return;
      }
      
      this.sliders.forEach((slider) => {
        this.setupSlider(slider);
      });
    };
    
    checkSplide();
  }
  
  /**
   * スライダーの設定
   */
  setupSlider(slider) {
    this.applySplideClasses(slider);

    const splide = new Splide(slider, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '0px',
      pagination: true,
      arrows: true,
      autoplay: false,
      interval: 3000,
      pauseOnHover: true,
    });

    splide.on('pagination:mounted', (data) => {
      this.movePaginationToContainer(slider, data);
      this.setupThumbnailPagination(splide, data);
      this.scrollCurrentPaginationToLeft(slider, data);
    });

    splide.on('pagination:updated', (data) => {
      this.movePaginationToContainer(slider, data);
      this.setupThumbnailPagination(splide, data);
      this.scrollCurrentPaginationToLeft(slider, data);
    });

    splide.mount();
    this.moveArrowsToContainer(slider);
    this.setupProgressBar(splide, slider);
    splide.on('moved', () => {
      this.scrollCurrentPaginationToLeft(slider);
    });
    this.splideInstances.push(splide);
  }

  /**
   * ページャーをサムネイル画像で表示
   */
  setupThumbnailPagination(splide, data) {
    data.items.forEach((item, index) => {
      const slide = splide.Components.Slides.getAt(index);
      if (!slide) {
        return;
      }

      const img = slide.slide.querySelector('img');
      if (!img) {
        return;
      }

      item.button.innerHTML = '';
      item.button.setAttribute('aria-label', `スライド ${index + 1}`);

      const thumb = document.createElement('img');
      thumb.src = img.currentSrc || img.src;
      thumb.alt = img.alt || '';
      thumb.loading = 'lazy';

      item.button.appendChild(thumb);
    });
  }

}
